import {
  Card,
  Alert,
  Radio,
  Form,
  Button,
  Modal,
  Tabs,
  Input,
  Spin,
  Checkbox,
  message,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import "./newAds.scss";
import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LogoIcon from "../../../../src/assets/images/upload_icon.svg";
import ImageCropper from "../../Components/ImageCropper/ImageCropper";
import Mobile from "../../Components/Mobile/Mobile";
import Advertisement from "../../Components/Advertisement/Advertisement";
import ListingView from "../mobile/ListingView/ListingView";
import DashboardView from "../mobile/DashboardView/DashboardView";
import { useDispatch, useSelector } from "react-redux";
import { createAd, getAdPlan, updateAd } from "../../../slices/ads/thunk";
import {
  getMobileData,
  getMobileListingData,
} from "../../../slices/mobile-view/thunk";
import { api } from "../../../helpers/api_helper";
import AsyncSelect from "../../Components/AsyncSelect/AsyncSelect";
import MapComponent from "../../Components/Map/Map";
import { businessInfo } from "../../../slices/businessInfo/thunk";
import { fetchData } from "../../../Services/FetchData";
import Iframe from "../../Components/Iframe/Iframe";
import closButton from "../../../../src/assets/images/close_icon.svg";
import { API_ENDPOINTS } from "../../../constants/apiEndPoints";
import Log from "../../../Services/Log";
import { ShimmerSimpleGallery } from "react-shimmer-effects";
// import bottomArrow from '../../../assets/images/bottom_arrow.svg'
import bottomArrow from "../../../assets/images/bottom_arrow_dark.svg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DirectionContentService } from "../../../Services/DirectionContentService";
import BillingAddress from "../../Components/BillingAddress/BillingAddress";
import { resetDuplicateAdThunk } from "../../../slices/DuplicateAd/reducer";
import { validationContent } from "../../../constants/Validation";
import { Popup_Toast } from "../../../constants/Popups_Toast";
import { PlaceholderContent } from "../../../constants/Placeholder";
import triangle from "../../../assets/images/action_triangle.svg";
import { bannerCreationPopup } from "../../../constants/BannerCreation";
import LocationSelection from "../../Components/LocationSelection/LocationSelection";

const NewAds = () => {
  let content = validationContent?.AD_CREATION;
  let popupContent = Popup_Toast;
  let placeholderContent = PlaceholderContent?.AD_CREATION;
  const actionDataRef = useRef();

  const dispatch = useDispatch();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const adItem = location.state?.adItem;
  const isDuplicateAd = location.state?.duplicate;
  const initiatePaymentStatus = location.state?.initiatePaymentStatus;
  const [previewEnabled, setPreviewEnabled] = useState(false);
  const allProfiles = useSelector((state) => state.Profiles);
  const business = useSelector((state) => state.BusinessInfoReducer);
  const [adData, setAdData] = useState(adItem || {});
  const [planId, setPlanId] = useState(null);
  const [defaultSelectedAction, setDefaultSelectedAction] = useState();
  const [editPlan, setEditPlan] = useState({
    plan: adItem?.plan || "",
    planId: adItem?.plan_id || "",
    plan: adItem?.plan || "",
    banner: adItem?.ad_images?.[0]?.original || "",
    action: adItem?.call_to_action || "",
    location: adItem?.location || "",
    lat: adItem?.geojson?.coordinates?.[1],
    lon: adItem?.geojson?.coordinates?.[0],
    ad_id: adItem?.ad_id,
  });
  const [planSelected, setPlanSelected] = useState("advanced");
  const [isDuplicate, setIsDuplicate] = useState(false);
  const mapRef = useRef(null);
  const socialInput = useRef(null);
  const navigate = useNavigate();
  let paymentFormSubmit = false;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAdData((prevData) => ({ ...prevData, [name]: value }));
  };
  const [plans, setPlans] = useState();
  const [imageUrl, setImageUrl] = useState(
    editPlan && editPlan.banner ? editPlan.banner : ""
  );
  const [logoUrl, setLogoUrl] = useState();
  const [visible, setVisible] = useState(true);
  const [logoError, setLogoError] = useState(false);
  const [imageCropperError, setImageCropperError] = useState();
  const [form] = Form.useForm();
  const [actionInstagramForm] = Form.useForm();
  const [actionFacebookForm] = Form.useForm();
  const [actionDirectionForm] = Form.useForm();
  const [billingAddress] = Form.useForm();
  const [locationForm] = Form.useForm();
  const [paymentForm] = Form.useForm();
  const [previewTab, setPreviewTab] = useState(1);
  const [plansActions, setPlansActions] = useState({});
  const [planPrice, setPlanPrice] = useState(999);
  const [currentAction, setCurrentAction] = useState([
    {
      _id: "669df6c3f0ffa86a3348c749",
      type: "enquiry",
      value: "",
      title: "Enquiry",
      bg_color: "#07A884",
      icon: "https://india-s3-dev-photo-video-uploads.s3.ap-south-1.amazonaws.com/market-place/icons/call_to_actions/enquiry.png",
      plans: ["marketplace_premium", "marketplace_advanced"],
      is_active: true,
    },
  ]);
  const [planAction, setPlanAction] = useState({ plan: "Basic", action: 1 });
  const [mobDashboardData, setMobDashboardData] = useState(
    useSelector((state) => state.MobileViewReducer)
  );
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [locationError, setLocationError] = useState(false);
  const [mapVisibility, setMapVisibility] = useState(false);
  const [mapClose, setMapClose] = useState(false);
  const [locationData, setLocationData] = useState();
  const [businessInfoData, setBusinessInfoData] = useState([]);
  const [locationUrl, setLocationUrl] = useState("");
  const [locationUrlMaxLength, setLocationUrlMaxLength] = useState();
  const [locationUrlError, setLocationUrlError] = useState(true);
  const [paymentGateway, setPaymentGateway] = useState([]);
  // temp
  const [paymentGatewayError, setPaymentGatewayError] = useState(false);
  const [paymentGateWayButtonStatus, setPaymentGatewayButtonStatus] =
    useState(true);
  const [paymentGatewaySelection, setPaymentGatewaySelection] = useState(null);
  const [selectedPaymentGateway, setSelectedPaymentGateway] = useState();
  const [paymentIframeLink, setPaymentIframeLink] = useState();
  const [paymentIframeModal, setPaymentIframeModal] = useState(false);
  const [adId, setAdId] = useState();
  const [paymentStatus, setPaymentStatus] = useState("");
  const [adCreationLoading, setAdCreationLoading] = useState(false);
  const [previewDisabled, setPreviewDisabled] = useState(true);
  const { pathname } = useLocation();
  const [actionHasData, setActionHasData] = useState();
  const [actionHasDataValue, setActionHasDataValue] = useState();
  const [selectedActionValue, setSelectedActionValue] = useState();
  const [updatedActionValue, setUpdatedActionValue] = useState();
  const [billingAddressPresent, setBillingAddressPresent] = useState(false);
  const [submitDisable, setSubmitDisable] = useState(false);
  // billing address new change

  const [billingAddressPopup, setBillingAddressPopup] = useState(false);
  const [billingAddressCompleted, setBillingAddressCompleted] = useState(false);
  let billingAddressFlag = false;
  const [stateList, setStateList] = useState([]);
  const [activeState, setActiveState] = useState();
  const [isCustomDropdownVisible, setCustomDropdownVisible] = useState(false);
  const [actionDataPosition, setActionDataPosition] = useState({
    left: "",
    right: "",
    top: "",
  });
  const [billing_address, setBillingAddress] = useState({
    name: "",
    country: {
      code: "IN",
      label: "India",
    },
    address: "",
    phone: "",
    area: "",
    landmark: "",
    city: {
      label: "",
    },
    state: {
      code: "",
      label: "",
    },
    pincode: "",
  });

  // action handling

  const [actionModals, setActionModals] = useState({
    whatsapp: false,
    instagram: false,
    facebook: false,
    direction: false,
  });
  const [originalActionModals, setOriginalActionModals] = useState({
    whatsapp: false,
    instagram: false,
    facebook: false,
    direction: false,
  });
  const [actionModalValues, setActionModalValues] = useState({
    whatsapp: "",
    instagram: "",
    facebook: "",
    direction: "",
  });
  const [prefilledActionValues, setPrefilledActionValues] = useState({
    whatsapp: false,
    instagram: false,
    facebook: false,
    direction: false,
  });
  const [actionButtonDisable, setActionButtonDisable] = useState({
    whatsapp: true,
    instagram: true,
    facebook: true,
    direction: true,
  });
  const [actionSelected, setActionSelected] = useState("enquiry");

  useEffect(() => {
    setBillingAddress((prev) => ({
      ...prev,
      state: {
        code: activeState?.code,
        label: activeState?.label,
      },
    }));
  }, [activeState]);
  const [
    billingAddressFormSubmitButtonStatus,
    setBillingAddressFormSubmitButtonStatus,
  ] = useState(false);

  let billingData;
  let businessAddress;
  let name;
  let businessFlag = false;
  useEffect(() => {
    billingData = business?.businessInfo?.billing_address;
    let contactNumber = business?.businessInfo?.contact_number;
    businessAddress = business?.businessInfo?.business_address;
    name = business?.businessInfo?.contact_name;

    console.log("business address", businessAddress);

    // checking the bulling address
    if (business) {
      if (!business?.businessInfo?.billing_address) {
        setBillingAddressPresent(false);
      } else {
        setBillingAddressPresent(true);
      }
      setActionModalValues({
        instagram: business?.businessInfo?.instagram ?? "",
        facebook: business?.businessInfo?.facebook ?? "",
        whatsapp: "+91 " + business?.businessInfo?.contact_number ?? "",
        direction: business?.businessInfo?.location ?? "",
      });
      setOriginalActionModals({
        instagram: business?.businessInfo?.instagram ?? "",
        facebook: business?.businessInfo?.facebook ?? "",
        whatsapp: "+91 " + business?.businessInfo?.contact_number ?? "",
        direction: business?.businessInfo?.location ?? "",
      });
    }
    // setBillingAddress(
    //     {
    //         name: billingData?.name || name || '',
    //         address: billingData?.address || businessAddress || '',
    //         phone: contactNumber || '',
    //         area: billingData?.address || '',
    //         landmark: billingData?.landmark || '',
    //         city: {
    //             label: billingData?.city?.label || ''
    //         },
    //         state: {
    //             code: billingData?.state?.code || '',
    //             label: billingData?.state?.label || ''
    //         },
    //         pincode: billingData?.pincode || ''
    //     }
    // )
    setBillingAddress((billing_address) => ({
      ...billing_address,
      name: name, // Update the name field
      address: businessAddress,
      phone: contactNumber,
    }));
  }, [business]);

  useEffect(() => {
    const isValid =
      billing_address?.name &&
      billing_address?.country &&
      billing_address?.country?.label &&
      billing_address?.country?.code &&
      billing_address?.address &&
      billing_address?.phone &&
      billing_address?.city &&
      billing_address?.city?.label &&
      billing_address?.state &&
      billing_address?.state?.label &&
      billing_address?.state?.code &&
      billing_address?.pincode &&
      billing_address?.pincode.length === 6;

    console.log("billing address current", billing_address);

    setBillingAddressFormSubmitButtonStatus(!isValid);

    // console.log('Checking billing address properties:', {
    //     name: billing_address?.name,
    //     countryLabel: billing_address?.country?.label,
    //     countryCode: billing_address?.country?.code,
    //     address: billing_address?.address,
    //     phone: billing_address?.phone,
    //     townCityLabel: billing_address?.city?.label,
    //     townCityCode: billing_address?.city?.code,
    //     stateLabel: billing_address?.state?.label,
    //     stateCode: billing_address?.state?.code,
    //     pincode: billing_address?.pincode
    // });
  }, [billing_address]);

  const [businessAddressForm] = Form.useForm();
  const businessAddressInitialValues = {
    name: billing_address?.name,
    country: billing_address?.country?.label || "India",
    address: billing_address?.address,
    phone: billing_address?.phone,
    area: billing_address?.area || "",
    landmark: billing_address?.landmark || "",
    city: billing_address?.city?.label || "",
    state: billing_address?.state?.label || "Kerala",
    pincode: billing_address?.pincode || "",
  };
  const [billingAddressModal, setBillingAddressModal] = useState(false);
  const [adBannerPopup, setAdBannerPopup] = useState(false);
  const handleBusinessAddressChange = (event) => {
    const { name, value } = event.target;
    setBillingAddress((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const billingAddressModalSubmit = () => {
    try {
      // update business info
      updateBillingAddressDetails({
        billing_address,
      });
    } catch (error) {
      console.log("Error fetching form values:", error);
    }
  };

  const updateBillingAddressDetails = async (info) => {
    try {
      setLoading(true);
      const data = await api.create(`${API_ENDPOINTS.BUSINESS_INFO.UPDATE}`, info);
      dispatch(businessInfo());
      setActionHasData(actionModalValues[actionSelected]);

      const values = form.getFieldsValue();
      billingAddressFlag = true;
      setBillingAddressCompleted(true);
      onFinish(values);
      setAdCreationLoading(true);
      setBillingAddressPopup(false);
      setBillingAddressModal(false);
    } catch (err) {
      console.log("Business info update error occurred:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(getMobileListingData(false));
    if (adItem) {
      let plan = adItem?.plan.toLowerCase();
      setPlanSelected(plan);
      let priceFiltered = adItem?.price.replace("₹", "");
      setPlanPrice(priceFiltered);
    }
    const fetchDataAsync = async () => {
      try {
        const endPoint = API_ENDPOINTS.GET_STATE;
        const fetchedData = await fetchData(endPoint);
        if (fetchedData) {
          console.log("fetched data", fetchedData);
          setStateList(fetchedData);
        }
      } catch (error) {
        console.error("Error fetching state data:", error); // More descriptive error message
      }
    };

    fetchDataAsync();
  }, []);
  useEffect(() => {
    console.log("billing address", billing_address);
  }, [billing_address]);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
  //  action validation

  const validateGoogleMapsUrl = (_, value) => {
    if (!value) {
      setActionButtonDisable((prevState) => ({
        ...prevState,
        direction: true,
      }));
      return Promise.resolve();
    } else if (
      !/^(https?:\/\/)?(www\.)?(google\.com\/maps\/|maps\.google\.com\/|maps\.app\.goo\.gl\/|goo\.gl\/maps\/)[a-zA-Z0-9\-]+/.test(
        value
      )
    ) {
      setActionButtonDisable((prevState) => ({
        ...prevState,
        direction: true,
      }));
      return Promise.reject(new Error(content?.InvalidLocationURL));
    }

    setActionButtonDisable((prevState) => ({
      ...prevState,
      direction: false,
    }));
    return Promise.resolve();
  };

  const validateInstagramUrl = (_, value) => {
    if (!value) {
      setActionButtonDisable((prevState) => ({
        ...prevState,
        instagram: true,
      }));
      return Promise.resolve();
    }

    const instagramUrlRegex =
      /^(https?:\/\/)?(www\.)?(instagram\.com\/[a-zA-Z0-9._]+\/?(\?.*)?)$/;

    if (!instagramUrlRegex.test(value)) {
      setActionButtonDisable((prevState) => ({
        ...prevState,
        instagram: true,
      }));
      return Promise.reject(new Error(content?.InvalidInstagramURL));
    }

    setActionButtonDisable((prevState) => ({
      ...prevState,
      instagram: false,
    }));
    return Promise.resolve();
  };

  const validateFacebookUrl = (_, value) => {
    if (!value) {
      setActionButtonDisable((prevState) => ({
        ...prevState,
        facebook: true,
      }));
      return Promise.resolve();
    } else if (
      !/^https:\/\/(www\.)?facebook\.com\/[a-zA-Z0-9(\.\_)?]+\/?$/.test(value)
    ) {
      setActionButtonDisable((prevState) => ({
        ...prevState,
        facebook: true,
      }));
      return Promise.reject(new Error(content?.InvalidFacebookURL));
    }
    setActionButtonDisable((prevState) => ({
      ...prevState,
      facebook: false,
    }));
    return Promise.resolve();
  };

  const validateWhatsappNumber = (_, value) => {
    if (!value) {
      setActionButtonDisable((prevState) => ({
        ...prevState,
        whatsapp: true,
      }));
      return Promise.resolve();
    } else if (!/^\+?[1-9]\d{9}$/.test(value)) {
      setActionButtonDisable((prevState) => ({
        ...prevState,
        whatsapp: true,
      }));
      return Promise.reject(
        new Error(
          "Please enter a valid WhatsApp number with exactly 10 digits!"
        )
      );
    }

    setActionButtonDisable((prevState) => ({
      ...prevState,
      whatsapp: false,
    }));
    return Promise.resolve();
  };

  let directionContent = DirectionContentService.content;

  const [actionModalData, setActionModalData] = useState({
    direction: {
      value: "direction",
      title: "Add Location Link from Google Maps",
      label: "Location",
      content: directionContent,
      placeholder: placeholderContent?.Direction,
      validator: validateGoogleMapsUrl,
      maxLength: 150,
    },
    whatsapp: {
      value: "whatsApp",
      title: "Enter Your WhatsApp Number",
      label: "Add WhatsApp number",
      description:
        "Please enter your WhatsApp number to allow customers to contact you directly.",
      placeholder: "1234567890",
      validator: validateWhatsappNumber,
      maxLength: 10,
    },
    instagram: {
      value: "instagram",
      title: "Add Your Instagram",
      label: "Add Instagram URL",
      description:
        "Increase your visibility by linking your Instagram profile. Make it the primary call-to-action for your ads!",
      placeholder: placeholderContent?.Instagram,
      validator: validateInstagramUrl,
      maxLength: 150,
    },
    facebook: {
      value: "facebook",
      title: "Add Your Facebook",
      label: "Add Facebook URL",
      description:
        "Increase your visibility by linking your Facebook Page. Make it the primary call-to-action for your ads!",
      placeholder: placeholderContent?.Facebook,
      validator: validateFacebookUrl,
      maxLength: 150,
    },
  });
  const [currentActionModalData, setCurrentActionModalData] = useState();

  useEffect(() => {
    let isMounted = true; // Add a flag to track if the component is mounted

    const fetchDataAsync = async () => {
      try {
        const endPoint = API_ENDPOINTS.PAYMENT.GATEWAY;
        const fetchedData = await fetchData(endPoint);
        console.log("fetched data", fetchedData);
        if (isMounted && fetchedData) {
          // Check if component is still mounted before updating state
          setPaymentGateway(fetchedData);
        }
      } catch (error) {
        console.error("Error fetching data:", error); // More descriptive error message
      }
    };

    fetchDataAsync();

    return () => {
      isMounted = false; // Cleanup function to mark the component as unmounted
    };
  }, [dispatch]);
  useEffect(() => {
    dispatch(getAdPlan());
  }, [dispatch]);

  useEffect(() => {
    setBusinessInfoData(business);
  }, [business, dispatch]);

  const plansData = useSelector((state) => state.Profiles.adPlans);
  const [plansDataLoading, setPlansDataLoading] = useState(true);
  useEffect(() => {
    if (plansData?.length > 0) {
      setPlans(plansData);
      setPlansDataLoading(false);
    }
    setPlansActions(
      plansData?.reduce((acc, el) => {
        acc[el.plan_type] = el.call_to_action;
        return acc;
      }, {})
    );
  }, [plansData]);

  useEffect(() => {
    if (previewEnabled) {
      if (editPlan.banner) {
        setVisible(false);
      }
    }
  }, [editPlan]);

  const [isModalOpen, setIsModalOpen] = useState({
    premiumPlan: false,
    advancedPlan: false,
  });
  const [callAction, setCallAction] = useState("enquiry");
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const onPaymentGatewayChange = (key) => {
    setSelectedPaymentGateway(key);
    setPaymentGatewaySelection(key);

    // Reset all checkboxes to false except for the selected one
    const updatedFields = Object.keys(
      paymentGateway?.payment_gateway_config || {}
    ).reduce((acc, itemKey) => {
      acc[itemKey] = itemKey === key;
      return acc;
    }, {});

    paymentForm.setFieldsValue(updatedFields);
  };
  const showModal = () => {
    setPreviewEnabled(true);
    // temporary
    if (logoUrl || editPlan?.banner) {
      if (planId === "marketplace_premium") {
        setIsModalOpen((prev) => ({
          ...prev,
          premiumPlan: true,
        }));
      } else {
        setIsModalOpen((prev) => ({
          ...prev,
          advancedPlan: true,
        }));
      }
    } else {
      setIsErrorModalOpen(true);
    }
  };
  const handleCancel = () => {
    setUpdatedActionValue("");
    setPreviewEnabled(false);
    setIsModalOpen(false);
    setIsErrorModalOpen(false);
    setMapVisibility(false);
    setLocationData(false);
    locationForm.resetFields();
    // setLocationUrl();
    setLocationUrlError(true);
    setPaymentGatewayError(false);
    setPaymentIframeModal(false);
    setAdBannerPopup(false)
  };

  const handleActionModalCancel = () => {
    // actionInstagramForm.resetFields();
    if (
      !actionModalValues[actionSelected] ||
      actionModalValues[actionSelected].trim() === ""
    ) {
      setActionModalValues((prev) => ({
        ...prev,
        [actionSelected]: originalActionModals[actionSelected],
      }));
    }
    setActionModalValues(originalActionModals);
    actionInstagramForm.resetFields();
    actionFacebookForm.resetFields();
    actionDirectionForm.resetFields();

    setActionModals({
      direction: false,
      whatsapp: false,
      instagram: false,
      facebook: false,
    });
  };

  const handlePaymentGatewayCancel = () => {
    setPaymentGatewayError(false);
    navigate("/live-ads");
  };

  const data = (value, logosrc) => {
    setVisible(value);
    setLogoUrl(logosrc);
    setLogoError(false);
    form.setFieldsValue({ logo: logosrc });
  };

  useEffect(() => {
    if (editPlan.banner) {
      setLogoError(false);
    }
  }, [editPlan]);
  useEffect(() => {
    if (locationUrl) {
      setUpdatedActionValue(locationUrl);
    } else {
      setUpdatedActionValue("");
    }
  }, [locationUrl]);

  useEffect(() => {
    if (adItem) {
      setVisible(false);
      let plan = String(adItem.plan).toLowerCase();
      findCurrentPlan(plan);
    }
  }, [plansData, plansActions]);

  function findCurrentPlan(value) {
    setCurrentAction(plansActions[value]);
  }

  useEffect(() => {
    form.setFieldsValue({ plan: planAction.plan, action: planAction.action });
  }, [planAction, form]);

  const handleTabChange = (key) => {
    setPreviewTab(key);
    Log("key", "info", key);
  };

  const onFinish = async (values) => {
    let hasError = false;

    let actionType = actionSelected;
    let actionValue =
      actionType === "enquiry" || actionType === ""
        ? ""
        : originalActionModals[actionType];
    let dataToSend;
    dataToSend = {
      call_to_action_type: actionType,
      call_to_action_value: actionValue,
      plan_id: planId || editPlan.planId || "marketplace_advanced",
      location: selectedLocation?.value || editPlan?.location,
      lat: selectedLocation?.lat || editPlan?.lat,
      lon: selectedLocation?.lon || editPlan?.lon,
      file: logoUrl || undefined,
      imageUrl: !logoUrl && editPlan?.banner ? editPlan.banner : undefined, // Include imageUrl only if logoUrl is empty
      ad_id: editPlan?.ad_id,
    };

    if (!logoUrl && !editPlan?.banner) {
      setLogoError(true);
      hasError = true;
    } else {
      // if (!originalActionModals[actionSelected]) {
      //     setActionModals(prev => ({
      //         ...prev, [actionSelected]: true
      //     }))
      // }

      console.log(
        actionType !== "enquiry" && !originalActionModals[actionSelected]
      );
      if (!dataToSend?.location) {
        setLocationError(true);
      } else if (
        actionType !== "enquiry" &&
        actionType !== "" &&
        (!originalActionModals[actionSelected] ||
          actionValue === undefined ||
          actionValue === "")
      ) {
        setActionModals({
          [actionType]: true,
        });
      } else {
        setLogoError(false);
        if (business) {
          let billing_address = business?.businessInfo?.billing_address;
          setBillingAddressPopup(!billingAddressPresent);
          setBillingAddressModal(!billingAddressPresent);
        }
        // updateBusinessInfo({ [values.call_to_action_type]: actionValue });
        if (billingAddressFlag || billingAddressPresent) {
          // if (billingAddressPresent) {
          //     setPaymentGatewayError(true);
          // }

          if (initiatePaymentStatus) {
            setLoading(true);
            try {
              const result = await dispatch(updateAd(dataToSend));
              if (result?.payload?.ad_id) {
                setAdId(result?.payload?.ad_id);
                setLoading(true);
                let data = adData;
                if (data?.status === "rejected") {
                  setPaymentGatewayError(false);
                  window.location.href = "/live-ads";
                } else {
                  if (selectedPaymentGateway) {
                    triggerPayment();
                  } else {
                    setPaymentGatewayError(true);
                  }
                }

                setAdCreationLoading(false);
              } else {
                console.log("Failed to create Ad:", result.payload);
                setAdCreationLoading(false);
              }
            } catch (error) {
              console.error("Error in creating Ad", error);
            }
          } else {
            try {
              setLoading(true);
              const result = await dispatch(createAd(dataToSend));

              if (result?.payload?.ad_id) {
                setAdId(result?.payload?.ad_id);
                setLoading(false);

                if (selectedPaymentGateway) {
                  triggerPayment();
                } else {
                  setPaymentGatewayError(true);
                }

                setAdCreationLoading(false);
              } else {
                setAdCreationLoading(false);

                if (result?.error) {
                  console.log(
                    "Failed to create Ad:",
                    result.error.message || result.error
                  );
                } else {
                  console.log("Failed to create Ad: Unknown error");
                }
              }
            } catch (error) {
              setLoading(false);
              setAdCreationLoading(false);
              console.error("Error in creating Ad:", error.message || error);
              console.error("Stack trace:", error.stack);
            }
          }
        }
      }
    }
    Log("action modal content", "info", currentActionModalData);
  };
  {
    locationError && (
      <Alert
        message="Please select a location."
        type="error"
        style={{ marginTop: "10px" }}
        className="cmn_label"
      />
    );
  }
  let plan;
  const onChangePlan = (e) => {
    const selectedPlan = e.target.value;
    if (selectedPlan === "advanced" || selectedPlan === "premium") {
      setActionSelected("enquiry");
    } else if (selectedPlan === "basic") {
      setActionSelected("");
    }
    setPlanSelected(selectedPlan);
    findCurrentPlan(selectedPlan);
    plan = plansData.filter((el, index) => el.plan_type === selectedPlan);
    setPlanPrice(plan[0]?.price);
    setPlanId(plan[0]?.plan_id);
    // temporary
    if (selectedPlan && selectedPlan == "basic") {
      setPreviewDisabled(true);
    } else {
      setPreviewDisabled(false);
    }
    setLocationUrl();
  };

  const oldPreviewDashboardData = useSelector(
    (state) => state.MobileViewDashboard
  );
  const oldPreviewListingData = useSelector((state) => state.MobileViewListing);

  const reset = () => {
    setLogoError(false);
    setVisible(true); // Show the upload icon and note
  };
  useEffect(() => {
    if (previewTab === 1) {
      dispatch(getMobileData(false));
    } else {
      dispatch(getMobileListingData(false));
    }
  }, [previewTab]);

  const previewDashboardData = useSelector(
    (state) => state.MobileViewDashboard
  );
  const previewListingData = useSelector((state) => state.MobileViewListing);

  const getInitialValues = () => {
    if (!editPlan) {
      return {
        planData: "basic",
        call_to_action_type: "enquiry",
        location: "",
      };
    }

    // Ensure planData and actionType are strings before calling toLowerCase
    let duplicatePlanData =
      typeof editPlan?.plan === "string" ? editPlan.plan.toLowerCase() : null;
    const planData = duplicatePlanData || "advanced";
    const actionType = editPlan?.action?.type
      ? editPlan?.action?.type.toLowerCase()
      : "enquiry";

    return {
      planData,
      call_to_action_type: actionType,
      location: editPlan.location ?? "",
    };
  };

  // const handleSubmitLocation = (values) => {
  //     setLocationUrl(values?.select_action_value)
  //     setLocationData(false);
  // };
  const handleActions = (values) => {
    console.log("values", values);
  };
  const handleActionChange = (e) => {
    setActionModalValues((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const onChangeAction = (e) => {
    setActionHasData();
    let value = e.target.value;
    setActionSelected(value);
    actionFunctionality(value);
    setPlanAction((prevState) => ({
      ...prevState,
      action: e.target.value,
    }));
  };
  const handleRadioClick = (e, type) => {
    let position = e.target.getBoundingClientRect();
    let messageHeight;
    let top = position.top + window.pageYOffset;
    if (actionDataRef?.current) {
      messageHeight = actionDataRef?.current?.offsetHeight;
    }
    setActionDataPosition({
      type: type,
      left: position.left,
      right: position.right,
      top: top,
      bottom: position.bottom,
      width: position.width,
      height: position.height,
      messageHeight: messageHeight,
    });
  };
  function actionFunctionality(value) {
    let action;
    if (value !== "enquiry") {
      if (businessInfoData?.businessInfo) {
        if (value == "direction") {
          action = businessInfoData?.businessInfo?.location;
        } else if (value == "whatsapp") {
          action = businessInfoData?.businessInfo?.contact_number;
        } else {
          action = businessInfoData?.businessInfo?.[value];
        }
        // if business already have data
        if (!action) {
          setActionModals((prev) => ({
            ...prev,
            [value]: true, // Toggle the specific action modal state
          }));
        } else {
          setLocationUrl(action);
          setActionHasData(value);
        }
        // setCurrentActionModalData(actionModalData[value])
        // setLocationData(true)
      }
      // setLocationData(true)
    } else {
      setLocationUrl();
      setActionHasData();
    }
  }

  const handleClickOutside = (event) => {
    if (mapRef.current && !mapRef.current.contains(event.target)) {
      setMapVisibility(false);
      setPlanAction((prevState) => ({
        ...prevState,
        action: "enquiry",
      }));
    }
  };
  const handlePaymentStatus = (status) => {
    setPaymentStatus(status);
  };
  const bannerPopupData = bannerCreationPopup;

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (paymentIframeLink) {
      setPaymentGatewayError(false);
      setPaymentIframeModal(true);
    }
  }, [paymentIframeLink]);

  const resetStatus = (reset) => {
    if (reset) {
      setPaymentIframeLink("");
    }
  };

  // useEffect(() => {
  //     if (adId) {
  //         setPaymentGatewayError(true);
  //     }
  // }, [adId])

  useEffect(() => {
    if (editPlan?.plan && editPlan.plan != "Basic") {
      setPreviewDisabled(false);
    }
    if (editPlan?.banner) {
      setIsDuplicate(true);
    } else {
      setIsDuplicate(false);
    }
  }, [editPlan]);

  useEffect(() => {
    dispatch(businessInfo());
  }, []);

  const updateBusinessInfo = async (info) => {
    try {
      const data = await api.create(`${API_ENDPOINTS.BUSINESS_INFO.UPDATE}`, info);
      setLoading(false);
      dispatch(businessInfo());
      setActionHasData(actionModalValues[actionSelected]);
    } catch (err) {
      console.log("business info updation error occured ");
    }
  };

  useEffect(() => {
    if (adItem) {
      setEditPlan({
        plan: adItem.plan || "",
        planId: adItem.plan_id || "",
        banner: adItem.ad_images?.[0]?.original || "",
        action: adItem.call_to_action || "",
        location: adItem.location || "",
        lat: adItem.geojson?.coordinates?.[1] ?? "",
        lon: adItem.geojson?.coordinates?.[0] ?? "",
        ad_id: adItem.ad_id || "",
      });
    }
  }, [adItem]);

  let modalContinue = (val) => {
    setLoading(true);
    handleActionModalCancel();
    if (val === "location") {
      updateBusinessInfo({ location: actionModalValues[actionSelected] });
    } else {
      updateBusinessInfo({
        [actionSelected]: actionModalValues[actionSelected],
      });
    }
  };
  useEffect(() => {
    setPrefilledActionValues((prevState) => ({
      whatsapp: !!actionModalValues.whatsapp,
      instagram: !!actionModalValues.instagram,
      facebook: !!actionModalValues.facebook,
      direction: !!actionModalValues.direction,
    }));
  }, [actionModalValues]);

  useEffect(() => {
    let values = billingAddress.getFieldsValue();

    if (billingAddressPopup && values) {
      console.log("form values", values);
      setBillingAddress((prev) => ({
        ...prev,
        name: values.name ?? "",
        country: {
          label: values.country?.label ?? prev.country?.label ?? "India",
          code: prev.country?.code ?? "+91",
        },
        address: values.address ?? prev.address ?? "",
        phone: values.phone ?? prev.phone ?? "",
        area: values.area ?? prev.area ?? "",
        landmark: values.landmark ?? prev.landmark ?? "",
        city: {
          label: values.city ?? prev.city?.label ?? "",
        },
        state: {
          label: values.state?.label ?? prev.state?.label ?? "",
          code: prev.state?.code ?? "",
        },
        pincode: values.pincode ?? prev.pincode ?? "",
      }));
    }
  }, [billingAddressPopup]);

  const handleCancelFn = () => {
    setBillingAddressModal(false);
  };

  const billingAddressModalStatus = (data) => {
    if (data) {
      const values = form.getFieldsValue();
      billingAddressFlag = true;
      setBillingAddressModal(false);
      setBillingAddressCompleted(true);
      onFinish(values);
      setAdCreationLoading(true);
      setBillingAddressPopup(false);
      setBillingAddressModal(false);
    }
  };

  const cropperError = (errorMessage) => {
    setImageCropperError(errorMessage);
  };

  useEffect(() => {
    if (paymentGatewayError) {
      setLoading(false);
    }
  }, [paymentGatewayError]);

  useEffect(() => {
    if (editPlan?.action?.type) {
      setActionSelected(editPlan?.action?.type);
    }
  }, [editPlan]);

  useEffect(() => {
    if (!selectedLocation) {
      setEditPlan((prev) => ({
        ...prev,
        location: "",
      }));
    }
  }, [selectedLocation]);
  const cancelPaymentGateway = () => {
    setPaymentGatewayError(false);
    setSubmitDisable(true);
    toast.warning(Popup_Toast?.BACK_WITHOUT_PAYMENT?.content, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 3000,
      className: "custom_toast",
    });
    setTimeout(() => {
      window.location.href = "/live-ads";
    }, 3000);
  };
  useEffect(() => {
    if (paymentGateway?.payment_gateway_config) {
      const paymentGatewayDataLength = Object.keys(
        paymentGateway.payment_gateway_config
      ).length;

      if (paymentGatewayDataLength === 1) {
        // Get the first key-value pair
        const firstPair = Object.entries(
          paymentGateway.payment_gateway_config
        )[0];

        if (firstPair) {
          const [key, value] = firstPair;
          setSelectedPaymentGateway(key);
        }
      }
    }
  }, [paymentGateway]);

  useEffect(() => {
    console.log("selectedPaymentGateway", selectedPaymentGateway);
  }, [selectedPaymentGateway]);

  const triggerPayment = () => {
    if (
      (!paymentFormSubmit && adId) ||
      (adItem.ad_id && adItem?.transaction_status !== "completed")
    ) {
      let payment;

      if (selectedPaymentGateway === "phonePe") {
        payment = "PHONE_PE";
      } else if (selectedPaymentGateway === "cashfree") {
        payment = "CASH_FREE";
      } else {
        payment = null;
      }
      // if(!planId){
      //     setPlanId(editPlan.ad_id)
      // }
      const data = {
        // ad_id: adId || adItem.ad_id,
        ad_id: adId || adItem?.ad_id,
        product_id: planId || adItem?.plan_id || "marketplace_advanced",
        payment_gateway: payment,
      };

      const initiatePayment = async () => {
        try {
          setLoading(true);
          const endPoint = "/initiatePayment";
          const result = await fetchData(endPoint, data);
          setLoading(false);
          if (result) {
            setPaymentIframeLink(result);
            setPaymentIframeModal(true);
          }
        } catch (error) {
          setLoading(false);
          console.error("Error fetching data:", error);
        }
      };

      initiatePayment();
      paymentFormSubmit = true;
      dispatch(resetDuplicateAdThunk());
    }
  };

  useEffect(() => {
    if (adId && selectedPaymentGateway) {
      triggerPayment();
    }
  }, [adId]);
  // useEffect(() => {

  //     if (!actionModalValues[actionSelected]) {
  //         setActionSelected((prev) => ({
  //             ...prev, actionSelected: 'dafdsad fafda fafd a'
  //         }))
  //     }
  // }, [actionModalValues[actionSelected]])

  useEffect(() => {
    if (logoError) {
      setTimeout(() => {
        setLogoError(false);
      }, 1000);
    }
  }, [logoError]);

  useEffect(() => {
    if (paymentIframeLink) {
      window.location.replace(paymentIframeLink);
    }
  }, [paymentIframeLink]);

  useEffect(()=>{
    console.log('selectedLocation' , selectedLocation)
  },[selectedLocation])

  return (
    <Card className="new_ad_wrap">

      {!plansDataLoading && (
        <ShimmerSimpleGallery
          card
          item={2}
          imageHeight='30vh'
          caption
          className="basic_shimmer_holder"
        />
      )}
      {loading && (
        <div className="spinner center">
          <Spin />
        </div>
      )}

      <div className="create_ad">
        <div className="new_ads_cnt">
          <div className="top_wrap show_preview preview_btn">
            <Link
              onClick={showModal}
            >
              Show Preview in Mobile
            </Link>
          </div>
          <Form
            form={form}
            className="form_body new_ad"
            onFinish={onFinish}
            onFinishFailed={(errorInfo) => {
              let errorName = errorInfo?.errorFields[0]?.name[0];
              console.log("Failed:", errorInfo);
              if (!logoUrl) {
                setLogoError(true);
              } else {
                setLogoError(false);
              }

              // if (!locationUrl) {
              //     setLocationError(true);
              // }
            }}
            initialValues={getInitialValues()}
          >
            <div className={`${initiatePaymentStatus} `}>
              <div className={`logo_upload text-center lg`}>
                {(visible || imageCropperError) && (
                  <div className="upload_description">
                    <span className="upload_icon">
                      <img
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                        src={LogoIcon}
                        alt="Logo Icon"
                      />
                    </span>
                    <div className="note">
                      <span className="title text_lg">Upload Your Poster</span>
                      <span
                        style={{
                          fontSize: "15px",
                          lineHeight: "1.7",
                          display: "block",
                          marginTop: ".8em",
                        }}
                      >
                        {/* Resolution : 1920 x 1080 <br /> */}
                        File Size: 5 MB (max)
                      </span>
                    </div>
                  </div>
                )}
                <ImageCropper
                  dataHandle={data}
                  type="wide"
                  duplicateImageUrl={editPlan.banner}
                  imageCropperError={cropperError}
                />
                {/* {
                                editPlan.banner ? (
                                    <div className="update_cropper_image">
                                        <img src={editPlan.banner} className='img_full cover' alt="" />
                                    </div>
                                )
                                    : null
                            } */}
                {imageCropperError && (
                  <Alert
                    className="cropper_error"
                    message={imageCropperError}
                    type="error"
                    style={{ marginTop: "10px" }}
                  />
                )}
              </div>
              <div className="ad_banner_help text_red">
                <a className="text_red text-center md" onClick={() => {
                  setAdBannerPopup(true)
                }}>Do you need help to create Ad banners for your business?</a>
              </div>
              <Form.Item
                name="planData"
                className={`plans mb-0 ${adData?.status === "rejected" && "rejected"
                  }`}
              >
                <Radio.Group
                  onChange={onChangePlan}
                  className={`${initiatePaymentStatus}`}
                >
                  {plans?.map((planData, index) => {
                    return (
                      <Radio value={planData.plan_type} key={index}>
                        <div className="plans_cnt">
                          <h3>{planData?.plan_title}</h3>
                          <span className="price text_xl">
                            ₹{planData?.price}
                          </span>
                          {index === 1 ? (
                            <div className="text_center">
                              <span className="popular_tag">Most Popular</span>
                            </div>
                          ) : null}
                          <ul className="features_list">
                            {planData?.feature_details?.map((feature, i) => (
                              <li key={i}>
                                <div>
                                  <span>{feature?.title}</span>
                                  {feature?.description && (
                                    <div
                                      className="xsm"
                                      style={{ lineHeight: "1.3" }}
                                    >
                                      {feature?.description}
                                    </div>
                                  )}
                                </div>
                              </li>
                            ))}
                          </ul>
                          <span className="validity">
                            <span>Validity : {planData.validity} days</span>
                          </span>
                        </div>
                      </Radio>
                    );
                  })}
                </Radio.Group>
              </Form.Item>
              <div className="offer_note text-center text_md ">
                <strong className="text_red ">Limited-Time Offer :</strong> Free access to user leads (Plan limits apply).
              </div>
              {/* logo */}
              <div
                style={{ display: planSelected === "basic" ? "none" : "block" }}
                className="action_wrap"
              >
                <label
                  htmlFor=""
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    display: "block",
                  }}
                  className=" center text_red sm "
                >
                  Call to Action
                </label>
                <Form.Item
                  className={`call_to_action ${planSelected === "basic" ? "multiple" : null
                    }`}
                >
                  <Radio.Group onChange={onChangeAction} value={actionSelected}>
                    {currentAction?.map((el, index) => {
                      return (
                        <Radio
                          onClick={(e) => {
                            handleRadioClick(e, el.type);
                          }}
                          className={` ${originalActionModals[el.type] && 'data_present'} ${actionSelected} ${actionHasData === el.type ? "highlighted_radio" : ""
                            }`}
                          value={el.type}
                          key={index}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <div>
                            <span>{el.type}</span>
                            <span className="icon_set">
                              <img src={el.icon} alt="" />
                            </span>
                          </div>
                        </Radio>
                      );
                    })}
                  </Radio.Group>
                </Form.Item>

                {(planSelected === "basic"
                  ? editPlan?.action?.type
                    ? editPlan.plan === "Premium"
                    : actionHasData && planSelected === "premium"
                  : actionHasData
                    ? planSelected === "premium"
                    : editPlan?.action?.type && editPlan.plan === "Premium") &&
                  actionSelected !== "enquiry" &&
                  originalActionModals[actionSelected] && (
                    <div
                      ref={actionDataRef}
                      className={`btm selected_action_value  ${actionSelected} 
                        }`}
                    >
                      <figure className="triangle">
                        <img src={triangle} alt="" />
                      </figure>
                      <div>
                        {actionSelected && (
                          <span>
                            {" "}
                            {actionSelected === "whatsapp" &&
                              "Mobile Number : "}{" "}
                            {originalActionModals[actionSelected]}
                          </span>
                        )}
                        {actionSelected !== "whatsapp" && (
                          <Button
                            type="primary"
                            className="xsm"
                            onClick={() => {
                              setActionModals((prev) => ({
                                ...prev,
                                [actionSelected]: true,
                              }));
                            }}
                          >
                            Change
                          </Button>
                        )}
                      </div>
                    </div>
                  )}
              </div>
              <div>
                <label
                  className="text_red sm "
                  style={{ display: "block", textAlign: "left" }}
                >
                  Choose your Target Location
                </label>
                <LocationSelection
                  errorHandle={(error) => {
                    setLocationError(error);
                  }}
                  disableStatus={initiatePaymentStatus}
                  apiUrl={`${API_ENDPOINTS.BASE_URL}/locationSearch`}
                  placeholder="Enter the target location"
                  selectedLocation={(data) => {
                    setSelectedLocation(data);
                    setLocationError(false);
                  }}
                  value={editPlan?.location || null}
                />
                {/* <AsyncSelect
                  errorHandle={(error) => {
                    setLocationError(error);
                  }}
                  disableStatus={initiatePaymentStatus}
                  apiUrl={`${API_ENDPOINTS.BASE_URL}/locationSearch`}
                  placeholder="Enter the target location"
                  selectedLocation={(data) => {
                    setSelectedLocation(data);
                    setLocationError(false);
                  }}
                  value={editPlan?.location || null}
                /> */}
                {locationError && ( // Update this conditional rendering for the location error message
                  <Alert
                    message={content?.MissingLocation}
                    type="error"
                    style={{ marginTop: "10px" }}
                    className="cmn_label"
                  />
                )}
                {/* <span
                  className="target_width"
                  style={{
                    fontSize: "14px",
                    textAlign: "left",
                    display: "block",
                  }}
                >
                  The Ad will reach users within a <strong>30km</strong> radius.
                </span> */}
              </div>
            </div>

            <Button
              type="primary"
              className="x_wide"
              htmlType="submit"
              style={{ margin: "3em auto", display: "block" }}
              disabled={submitDisable}
            >
              {/* {initiatePaymentStatus && 'Make Payment' || 'Submit'} */}
              {adData?.status === "rejected" ? "Resubmit" : "Submit"}
            </Button>

            {/* {
                            adCreationLoading && (
                                <div className="spinner sm text-center">
                                    <Spin />
                                </div>
                            )
                        } */}
          </Form>
        </div>
      </div>
      {/* preview modal */}
      <Modal
        afterClose={() => (document.body.style.overflow = "initial")}
        className="sm_modal new_add_modal"
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div className="mobile_preview_top">
              <h2 className="text-center text_red">Ad Preview</h2>
              <p
                style={{
                  fontWeight: "400",
                  textAlign: "center",
                  fontSize: "14px",
                }}
                className="mb-0"
              >
                See how your Ad looks in the Lumi App.
              </p>
            </div>
            <Button
              type="text"
              onClick={handleCancel}
              className="custom-close-button"
            >
              Close
            </Button>
          </div>
        }
        visible={isModalOpen.advancedPlan}
        onCancel={handleCancel}
        footer={null}
        closeIcon={null} // This hides the default close icon
      >
        <Mobile action={callAction} previewTab={'listing'}>
          <ListingView data={previewListingData?.data}>
            <Advertisement
              action={actionSelected}
              poster={logoUrl || editPlan.banner}
              icon={actionSelected}
            />
          </ListingView>
        </Mobile>
      </Modal>
      {/* <Modal className='sm_modal new_add_modal'
                title={
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                        <div className='mobile_preview_top'>
                            <h2 className='text-center text_red'>Ad Preview</h2>
                            <p style={{ fontWeight: "400", fontSize: "14px" }} className='mb-0'>See how your Ad looks in the Lumi App. </p>
                        </div>
                        <Button type="text" onClick={handleCancel} className="custom-close-button">
                            Close
                        </Button>
                    </div>
                }
                visible={isModalOpen.PremiumPlan}
                onCancel={handleCancel}
                footer={null}
                closeIcon={null}  // This hides the default close icon
            >
                <Mobile action={callAction}>
                    <DashboardView data={previewDashboardData.data}>
                        <Advertisement
                            action={'whatsapp'}
                            poster={logoUrl || editPlan.banner}
                            // icon={dashboardAdIcon}
                            title={'Connect us on'}
                        />
                    </DashboardView>
                </Mobile>
            </Modal> */}
      <Modal
        afterClose={() => (document.body.style.overflow = "initial")}
        className="sm_modal new_add_modal"
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div className="mobile_preview_top">
              <h2 className="text-center text_red">Ad Preview</h2>
              <p
                style={{ fontWeight: "400", fontSize: "14px" }}
                className="mb-0"
              >
                See how your Ad looks in the Lumi App.
              </p>
            </div>
            <Button
              type="text"
              onClick={handleCancel}
              className="custom-close-button"
            >
              Close
            </Button>
          </div>
        }
        visible={isModalOpen.premiumPlan}
        onCancel={handleCancel}
        footer={null}
        closeIcon={null} // This hides the default close icon
      >
        <Tabs
          className="mobile_preview_tab"
          defaultActiveKey="1"
          onChange={handleTabChange}
          items={[
            {
              label: <Button type="primary">Dashboard</Button>,
              key: "1",
              children: (
                <Mobile action={callAction} previewTab={'dashboard'}>
                  <DashboardView data={previewDashboardData?.data}>
                    <Advertisement
                      action={actionSelected}
                      poster={logoUrl || editPlan.banner}
                      icon={actionSelected}
                    />
                  </DashboardView>
                </Mobile>
              ),
            },
            {
              label: <Button type="primary">Match Listing</Button>,
              key: "2",
              children: (
                <Mobile action={callAction} previewTab={'listing'}>
                  <ListingView data={previewListingData?.data}>
                    <Advertisement
                      action={actionSelected}
                      poster={logoUrl || editPlan.banner}
                      icon={actionSelected}
                    />
                  </ListingView>
                </Mobile>
              ),
            },
          ]}
        />
      </Modal>

      {/* <Modal className='sm_modal location_modal tex-center' open={paymentIframeModal} footer={null} onCancel={handleCancel}>
                <Iframe src={paymentIframeLink} />
            </Modal> */}

      {/* <div className="payment_parent">
                <div className="payment_frame_wrap">
                    <button className='dflt_btn_removed'>
                        <img src={closButton} alt="" />
                    </button>
                    <Iframe src={'https://mercury-uat.phonepe.com/transact/simulator?token=c96tA4gbNWDO9lTPoOwaojyjiOwa5bfGvEJXEKW'} />
                </div>
            </div> */}
      {/* {paymentIframeLink && (
        <div className="">
          <Iframe
            resetStatus={resetStatus}
            src={paymentIframeLink}
            status={true}
            onPaymentStatus={handlePaymentStatus}
          />
        </div>
      )} */}
      {/* billing address popup*/}

      <Modal
        afterClose={() => (document.body.style.overflow = "initial")}
        className="sm_modal  billing_address_modal medium_modal text-center center_modal"
        open={billingAddressModal}
        onCancel={handleCancelFn}
        footer={
          <Button
            key="close"
            type="text"
            className="short custom_btn md"
            onClick={handleCancelFn}
          >
            Close
          </Button>
        }
      >
        <BillingAddress
          btnStatus={false}
          uploadStatus={billingAddressModalStatus}
          modalData={billingAddressModal}
        />
      </Modal>
      {logoError && message.error(content?.MissingBanner, 3)}
      <Modal
        className="sm_modal work_modal tex-center"
        open={isErrorModalOpen}
        footer={null}
        onCancel={handleCancel}
      >
        <p className="text-center text_red mb-0">
          {popupContent?.AD_CREATION?.SHOW_MOBILE_PREVIEW?.content}
        </p>
      </Modal>
      {/* <div>
                <div className={`map_wrap ${mapVisibility ? 'active' : ''}`}>
                    <div className={`map_holder ${mapVisibility ? 'active' : ''}`} ref={mapRef}>
                        <MapComponent />
                    </div>
                </div>
            </div> */}

      {/* action modals */}

      {/* whatsapp modal */}
      <Modal
        afterClose={() => (document.body.style.overflow = "initial")}
        className="sm_modal location_modal wide_modal text-center center_modal "
        open={actionModals.whatsapp}
        footer={[
          <Button
            key="close"
            type="text"
            className="short custom_btn"
            onClick={handleActionModalCancel}
          >
            Close
          </Button>,
        ]}
        onCancel={handleActionModalCancel}
      >
        <div className="wrap">
          <div className="text-center title_wrap">
            <h2 className="text_red mb text_md">
              {actionModalData?.whatsapp?.title}
            </h2>
            <p className="md">{actionModalData?.whatsapp?.description}</p>
          </div>

          {/* action modal */}
          <Form>
            <Form.Item
              name="whatsapp" // Ensure the field name is properly connected
              className="custom_error"
              rules={[{ validator: actionModalData?.whatsapp?.validator }]}
            >
              <div className="input_holder">
                <label className="input_label text_capitalize text_red d-block">
                  {currentActionModalData?.label}
                </label>
                <Input
                  name="whatsapp"
                  ref={socialInput}
                  maxLength={actionModalData?.whatsapp?.maxLength}
                  onChange={(e) => handleActionChange(e)}
                  className="input_field text_transform_normal"
                  placeholder={actionModalData?.whatsapp?.placeholder}
                  onKeyDown={(e) => {
                    if (
                      !(
                        e.key === "Backspace" ||
                        e.key === "Delete" ||
                        /^\d$/.test(e.key)
                      )
                    ) {
                      e.preventDefault();
                    }
                  }}
                  value={actionModalValues.whatsapp}
                />
              </div>
            </Form.Item>

            <div className="button_wrap">
              <div className="text-center">
                <Button
                  className="wide"
                  type="primary"
                  disabled={actionButtonDisable?.whatsapp}
                  onClick={() => {
                    modalContinue();
                  }}
                >
                  Continue
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </Modal>
      {/* instagram modal */}
      <Modal
        afterClose={() => (document.body.style.overflow = "initial")}
        className="sm_modal location_modal wide_modal text-center center_modal"
        open={actionModals.instagram}
        footer={[
          <Button
            key="close"
            type="text"
            className="short custom_btn"
            onClick={handleActionModalCancel}
          >
            Close
          </Button>,
        ]}
        onCancel={handleActionModalCancel}
      >
        <div className="wrap">
          <div className="text-center title_wrap">
            <h2 className="text_red mb text_md">
              {actionModalData?.instagram?.title}
            </h2>
            <p className="md">{actionModalData?.instagram?.description}</p>
          </div>

          {/* action modal */}
          <Form form={actionInstagramForm}>
            <Form.Item
              name="instagram" // Ensure the field name is properly connected
              className="custom_error"
              rules={[{ validator: actionModalData?.instagram?.validator }]}
            >
              <div className="input_holder ">
                <label className="input_label text_capitalize text_red d-block">
                  {actionModalData?.instagram?.label}
                </label>
                <Input
                  name="instagram"
                  ref={socialInput}
                  maxLength={actionModalData?.instagram?.maxLength}
                  onChange={(e) => handleActionChange(e)}
                  className="input_field text_transform_normal"
                  placeholder={actionModalData?.instagram?.placeholder}
                  value={actionModalValues.instagram}
                />
              </div>
            </Form.Item>

            <div className="button_wrap">
              <div className="text-center">
                <Button
                  type="primary"
                  className="wide"
                  disabled={actionButtonDisable?.instagram}
                  onClick={modalContinue}
                >
                  Continue
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </Modal>
      {/* facebook modal */}
      <Modal
        afterClose={() => (document.body.style.overflow = "initial")}
        className="sm_modal location_modal wide_modal text-center center_modal"
        open={actionModals.facebook}
        onCancel={handleActionModalCancel}
        footer={[
          <Button
            key="close"
            type="text"
            className="short custom_btn"
            onClick={handleActionModalCancel}
          >
            Close
          </Button>,
        ]}
      >
        <div className="wrap">
          <div className="text-center title_wrap">
            <h2 className="text_red mb text_md">
              {actionModalData?.facebook?.title}
            </h2>
            <p className="md">{actionModalData?.facebook?.description}</p>
          </div>

          {/* action modal */}
          <Form form={actionFacebookForm}>
            <Form.Item
              name="facebook" // Ensure the field name is properly connected
              className="custom_error"
              rules={[
                { required: false },
                { validator: actionModalData?.facebook?.validator },
              ]}
            >
              <div className="input_holder">
                <label className="input_label text_capitalize text_red d-block">
                  {actionModalData?.facebook?.label}
                </label>
                <Input
                  name="facebook"
                  ref={socialInput}
                  maxLength={actionModalData?.facebook?.maxLength}
                  onChange={(e) => handleActionChange(e)}
                  className="input_field text_transform_normal"
                  placeholder={actionModalData?.facebook?.placeholder}
                  value={actionModalValues.facebook}
                />
              </div>
            </Form.Item>

            <div className="button_wrap">
              <div className="text-center">
                <Button
                  className="wide"
                  type="primary"
                  disabled={actionButtonDisable?.facebook}
                  onClick={modalContinue}
                >
                  Continue
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </Modal>
      {/* direction popup */}
      <Modal
        afterClose={() => (document.body.style.overflow = "initial")}
        className="sm_modal  location_modal wide_modal text-center center_modal"
        open={actionModals.direction}
        footer={[
          <Button
            key="close"
            type="text"
            className="short custom_btn"
            onClick={handleActionModalCancel}
          >
            Close
          </Button>,
        ]}
        onCancel={handleActionModalCancel}
      >
        <div className="wrap">
          <div className="text-center title_wrap">
            <h2 className="text_red mb text_md">
              {actionModalData?.direction?.title}
            </h2>
            <div className="content_wrap" style={{ textAlign: "left" }}>
              {actionModalData?.direction?.content}
            </div>
          </div>

          {/* action modal */}
          <Form form={actionDirectionForm}>
            <Form.Item
              name="direction" // Ensure the field name is properly connected
              className="custom_error"
              rules={[{ validator: actionModalData?.direction?.validator }]}
            >
              <div className="input_holder location_input_holder">
                <label className="input_label text_capitalize text_red d-block">
                  {actionModalData?.direction?.label}
                </label>
                <Input
                  name="direction"
                  ref={socialInput}
                  maxLength={actionModalData?.direction?.maxLength}
                  onChange={(e) => handleActionChange(e)}
                  className="input_field text_transform_normal"
                  placeholder={actionModalData?.direction?.placeholder}
                  value={actionModalValues.direction}
                />
              </div>
            </Form.Item>

            <div className="button_wrap">
              <div className="text-center">
                <Button
                  type="primary"
                  disabled={actionButtonDisable?.direction}
                  className="wide"
                  onClick={() => {
                    modalContinue("location");
                  }}
                >
                  Continue
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </Modal>
      <Modal
        afterClose={() => (document.body.style.overflow = "initial")}
        className="sm_modal center_modal  location_modal payment_gateway_modal text-center"
        open={paymentGatewayError}
        onCancel={() => {
          cancelPaymentGateway();
        }}
        footer={[
          <Button
            key="close"
            type="text"
            className="short custom_btn"
            onClick={cancelPaymentGateway}
          >
            Close
          </Button>,
        ]}
      >
        <h2 className="text_lg text_red">Choose Payment Gateway</h2>
        <p className="md">Please choose any one payment gateway from below. </p>
        {/* <Form onFinish={() => {

                }}>
                    <Form.Item>
                        <Checkbox
                            checked={paymentGatewaySelection === 'checkbox1'}
                            onChange={() => onPaymentGatewayChange('checkbox1')}
                        >
                            cashFree
                        </Checkbox>
                    </Form.Item>
                    <Form.Item>
                        <Checkbox
                            checked={paymentGatewaySelection === 'checkbox2'}
                            onChange={() => onPaymentGatewayChange('checkbox2')}
                        >
                            phonePe
                        </Checkbox>
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form> */}

        <Form
          className="payment_gateway"
          form={paymentForm}
          onFinish={(values) => {
            if (adItem?.transaction_status !== "completed") {
              triggerPayment();
            }
            // if (!paymentFormSubmit) {
            //     let payment;

            //     if (selectedPaymentGateway === 'phonePe') {
            //         payment = 'PHONE_PE';
            //     } else if (selectedPaymentGateway === 'cashfree') {
            //         payment = 'CASH_FREE';
            //     } else {
            //         payment = null;
            //     }
            //     // if(!planId){
            //     //     setPlanId(editPlan.ad_id)
            //     // }
            //     const data = {
            //         ad_id: adId || adItem.ad_id,
            //         product_id: planId || adItem?.plan_id || 'marketplace_basic',
            //         payment_gateway: payment,
            //     };

            //     const initiatePayment = async () => {
            //         try {
            //             setLoading(true)
            //             const endPoint = '/initiatePayment';
            //             const result = await fetchData(endPoint, data);
            //             setLoading(false)
            //             if (result) {
            //                 setPaymentIframeLink(result);
            //                 setPaymentIframeModal(true);
            //             }
            //         } catch (error) {
            //             setLoading(false)
            //             console.error('Error fetching data:', error);
            //         }
            //     };

            //     initiatePayment();
            //     paymentFormSubmit = true;
            // }
          }}
        >
          {/* <h2 className='text_md'>
                        Pay : <span className='text_xl text_red amount'><span>₹</span>{planPrice}</span>
                    </h2> */}
          <div className="input_wrap">
            {Object.entries(paymentGateway?.payment_gateway_config || {}).map(
              ([key, value], index) => (
                <Form.Item key={index} name={key} valuePropName="checked">
                  <Checkbox
                    checked={paymentGatewaySelection === key}
                    onChange={() => onPaymentGatewayChange(key)}
                  >
                    {key}
                  </Checkbox>
                </Form.Item>
              )
            )}
          </div>
          <Form.Item className="button_holder">
            <Button
              type="primary"
              className="md wide"
              htmlType="submit"
              disabled={!selectedPaymentGateway}
              onClick={() => {
                setLoading(false);
              }}
            >
              Continue
            </Button>
            {/* <Button type="primary" htmlType="submit" onClick={handlePaymentGatewayCancel} >
                            Cancel
                        </Button> */}
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        className="sm_modal work_modal banner_creation_popup tex-center"
        open={adBannerPopup}
        footer={null}
        onCancel={handleCancel}
      >
        <div className="cnt">
          <div className="top">
            <div className="banner">
              <figure className="bg"><img src={bannerPopupData?.company_info?.banner_bg} alt="" /></figure>
              <figure className="cnt center">
                <img src={bannerPopupData?.company_info?.digital_cnt} alt="" />
              </figure>
              <div className="social_visit_wrap">
                <ul className="social_icons">
                  {
                    bannerPopupData.social_media_icons.map((el, index) => {
                      return (
                        <li key={index}>
                          <a href={el.url} target="_blank" rel="noopener noreferrer" alt={el.platform}>
                            <img src={el.icon} alt={el.platform} /> {/* Use el.platform as alt */}
                          </a>
                        </li>
                      );
                    })
                  }
                </ul>
                <div className="visit_block">
                  <span className="xsm">Visit our website</span>
                  <a href="https://fliptreedigital.com/" className="xsm2">www.fliptreedigital.com</a>
                </div>
              </div>
            </div>
          </div>
          <div className="bottom">
            <div className="cnt">
              <p>At <strong>FlipTree Digital</strong>, We are a full-scale advertising agency with an in-house media, graphic, and production studio. We provide the creative fuel to help clients across the globe take their business to the next level.Specializing in digital marketing, brand building, social media, creatives, and marketing strategy. Let us manage your brand while you focus on growing your business. </p>
              <div className="offers_block">
                <span>{bannerPopupData?.company_info?.special_offer}</span>
                <ul>
                  <li>
                    <span>{bannerPopupData?.company_info?.contact?.phone?.title}</span>
                    <a href={`tel:${bannerPopupData?.company_info?.contact?.phone?.number}`}>
                      {bannerPopupData?.company_info?.contact?.phone?.formatted}
                    </a>
                  </li>
                  <li>
                    <a href={`mailto:${bannerPopupData?.company_info?.contact?.email?.mail}`}>
                      <span>{bannerPopupData?.company_info?.contact?.email?.title}</span>
                      {bannerPopupData?.company_info?.contact?.email?.mail}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </Card>
  );
};

export default NewAds;
